import React from 'react'

import {
  arrayToObject,
  formatLastMessage,
  loadTaggedUsers
} from '../../../../../../utilities'
import { useSocket } from '../../../../../../providers/SocketProvider'
import { useUserAPI } from '../../../../../../providers/UserAPIProvider'
import { useAgent } from '../../../../../../providers/AgentProvider'

type LatestActivityProps = {
  convo: {
    fullUsers: any[]
  }
  activity?: { content?: string }
}

const LatestActivity: React.FC<LatestActivityProps> = ({ convo, activity }) => {
  const { allAgents } = useSocket()
  const { allUsers, loadUser } = useUserAPI()
  const { currentUser } = useAgent()

  const [lastLoaded, setLastLoaded] = React.useState('')

  const { fullUsers } = convo

  // Loads all tagged users from a message
  React.useEffect(() => {
    if (
      !activity ||
      activity.content === lastLoaded ||
      typeof activity.content !== 'string'
    ) {
      return
    }

    const { content = '' } = activity
    loadTaggedUsers(content, loadUser)

    setLastLoaded(content)
  }, [activity, lastLoaded, loadUser])

  return (
    <>
      {formatLastMessage(
        activity,
        [...allAgents, ...fullUsers],
        { ...allUsers, ...arrayToObject(fullUsers) },
        currentUser
      )}
    </>
  )
}

export default LatestActivity
